module.exports = __webpack_public_path__ + "static/media/10_3.146c3bb5.jpg";